<template>
    <div v-if="content?.data?.crossSellings != null" class="flex flex-col gap-6 md:gap-10">
        <div v-for="crossSelling in content.data.crossSellings" :key="crossSelling.id">
            <h2
                v-if="crossSelling?.translated?.name"
                class="font-semibold text-xl"
            >
                {{ crossSelling?.translated?.name }}
            </h2>

            <LazyProductSlider
                v-if="content?.data?.crossSellings.length > 0"
                :products="mapProductsForSlider(crossSelling?.products)"
                :is-cross-sell="true"
                slider-id="cross_selling"
                slider-title="Cross Selling"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'
import type { ListingItemProduct } from '~/types/ListingItems'

defineProps<{
    content: Schemas['CmsElementCrossSellings']
}>()

const mapProductsForSlider = (products: Schemas['Product'][] = []): ListingItemProduct[] => {
    return products.map((product, index) => ({
        pos: index,
        type: 'product',
        data: product
    }))
}
</script>
